import  {  useEffect, useState } from 'react';
import { useReversalService } from '../../service/reversal';

const useGetReversalInfos = (id: any) => {
  const [data, setData] = useState<any[]>([]);
  const [error, setError] = useState<any>()
  const [isLoading, setIsLoading] = useState<Boolean>(false)
  const {getReversalTreeById} = useReversalService()
    useEffect(() => {
      setIsLoading(true)
    const fetchData = async () => {
      try {
        const response = await getReversalTreeById(id);
        setData(response.data);
      } catch (err) {
        setError(err);
      }
      finally {
        setIsLoading(false)
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

    
  
  return {
    data,
    error,
    isLoading
  };
};

export default useGetReversalInfos;
